import { ProductRankingQueryParams } from './validate';
import { isBoolean, isNumber } from '@fxts/core';

export const createProductRankingSearchParams = (query: ProductRankingQueryParams): URLSearchParams => {
  if (!query.rank_type) {
    throw new TypeError(`rank_type is required, ${query.rank_type}`);
  }

  const searchParams = new URLSearchParams();

  searchParams.append('rank_type', query.rank_type);

  if (isNumber(query.cate_list_id)) {
    searchParams.append('cate_list_id', query.cate_list_id.toString());
  }

  if (isBoolean(query.exclude_sold_out) && query.exclude_sold_out) {
    searchParams.append('exclude_sold_out', query.exclude_sold_out.toString());
  }

  return searchParams;
};
